import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { ButtonBaseProps } from '@mui/material';

export type ButtonProps = Readonly<LoadingButtonProps & ButtonBaseProps>;

export function Button(props: ButtonProps): React.JSX.Element {
  return <LoadingButton {...props} />;
}
